import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

export function useVendorAccess() {
  const { user, isVendor } = useAuth();
  const navigate = useNavigate();
  const currentPath = window.location.pathname + window.location.search;
  
  useEffect(() => {
    if (!user) {
      const returnTo = encodeURIComponent(currentPath);
      navigate(`/auth?returnTo=${returnTo}`);
      return;
    }
    
    if (!isVendor) {
      toast.error('Access denied. This area is for approved vendors only.');
      navigate('/');
    }
  }, [user, isVendor, navigate, currentPath]);
  
  return { user, isVendor };
}
